'use strict';
import React from 'react';
import classNames from 'classnames';
import Icon from '../components/icon';

/**
 * Checkbox component.
 * Always nest the Checkbox-input and Checkbox-icon within a checkbox label to ensure proper positioning.
 * Checkbox-icon must follow Checkbox-input.
 * Default display style for labels is inline-block, add .Checkbox-label--stacked for vertical display.
 *
 * @extends {React.Component}
 * @property {String} name Sets the name attribute of the checkbox.
 * @property {String} value Sets the value assigned to this checkbox.
 * @property {Boolean} disabled Renders the checkbox as disabled.
 * @property {Boolean} stacked Renders the checkbox as vertically stacked.
 * @property {Function} onChange Callback on value change.
 */
class Checkbox extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName () {
    return classNames({
      'Checkbox-label': true,
      'Checkbox-label--stacked': this.props.stacked,
      'is-disabled': this.props.disabled
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, disabled, stacked, ...otherProps } = this.props;

    return (
      <label className={this.getClassName()}>
        <input {...otherProps}
          className="Checkbox-input"
          disabled={disabled}
          type="checkbox" />
        <Icon className="Checkbox-icon"/>
        {children}
      </label>
    );
  }
}

/**
 * @prop {propTypes} propTypes - required attributes for the Checkbox component
 */
Checkbox.propTypes = {
  disabled: React.PropTypes.bool,
  stacked: React.PropTypes.bool,
  value: React.PropTypes.any.isRequired
};

Checkbox.defaultProps = {
  disabled: false,
  stacked: false
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/checkbox.jsx